export const mapPin = (
  <svg
    width="15"
    height="21"
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.57333 0.5C3.57938 0.5 0.330078 3.7493 0.330078 7.74321C0.330078 12.6998 6.81208 19.9763 7.08805 20.2837C7.34727 20.5724 7.79985 20.5719 8.0586 20.2837C8.33458 19.9763 14.8166 12.6998 14.8166 7.74321C14.8165 3.7493 11.5672 0.5 7.57333 0.5ZM7.57333 11.3875C5.56387 11.3875 3.92911 9.75267 3.92911 7.74321C3.92911 5.73376 5.56391 4.09899 7.57333 4.09899C9.58275 4.09899 11.2175 5.7338 11.2175 7.74325C11.2175 9.75271 9.58275 11.3875 7.57333 11.3875Z"
      fill="#3A6D33"
    />
  </svg>
);

export const searchIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2812 14.5938C16.5625 14.9062 16.5625 15.375 16.25 15.6562L15.375 16.5312C15.0938 16.8438 14.625 16.8438 14.3125 16.5312L11.2188 13.4375C11.0625 13.2812 11 13.0938 11 12.9062V12.375C9.875 13.25 8.5 13.75 7 13.75C3.40625 13.75 0.5 10.8438 0.5 7.25C0.5 3.6875 3.40625 0.75 7 0.75C10.5625 0.75 13.5 3.6875 13.5 7.25C13.5 8.78125 12.9688 10.1562 12.125 11.25H12.625C12.8125 11.25 13 11.3438 13.1562 11.4688L16.2812 14.5938ZM7 11.25C9.1875 11.25 11 9.46875 11 7.25C11 5.0625 9.1875 3.25 7 3.25C4.78125 3.25 3 5.0625 3 7.25C3 9.46875 4.78125 11.25 7 11.25Z"
      fill="#555555"
    />
  </svg>
);

export const bars = (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.99 11.75C16.24 11.75 16.49 12 16.49 12.25V13.25C16.49 13.5312 16.24 13.75 15.99 13.75H5.48999V14.25C5.48999 14.5312 5.23999 14.75 4.98999 14.75H3.98999C3.70874 14.75 3.48999 14.5312 3.48999 14.25V13.75H0.98999C0.70874 13.75 0.48999 13.5312 0.48999 13.25V12.25C0.48999 12 0.70874 11.75 0.98999 11.75H3.48999V11.25C3.48999 11 3.70874 10.75 3.98999 10.75H4.98999C5.23999 10.75 5.48999 11 5.48999 11.25V11.75H15.99ZM15.99 6.75C16.24 6.75 16.49 7 16.49 7.25V8.25C16.49 8.53125 16.24 8.75 15.99 8.75H13.49V9.25C13.49 9.53125 13.24 9.75 12.99 9.75H11.99C11.7087 9.75 11.49 9.53125 11.49 9.25V8.75H0.98999C0.70874 8.75 0.48999 8.53125 0.48999 8.25V7.25C0.48999 7 0.70874 6.75 0.98999 6.75H11.49V6.25C11.49 6 11.7087 5.75 11.99 5.75H12.99C13.24 5.75 13.49 6 13.49 6.25V6.75H15.99ZM15.99 1.75C16.24 1.75 16.49 2 16.49 2.25V3.25C16.49 3.53125 16.24 3.75 15.99 3.75H9.48999V4.25C9.48999 4.53125 9.23999 4.75 8.98999 4.75H7.98999C7.70874 4.75 7.48999 4.53125 7.48999 4.25V3.75H0.98999C0.70874 3.75 0.48999 3.53125 0.48999 3.25V2.25C0.48999 2 0.70874 1.75 0.98999 1.75H7.48999V1.25C7.48999 1 7.70874 0.75 7.98999 0.75H8.98999C9.23999 0.75 9.48999 1 9.48999 1.25V1.75H15.99Z"
      fill="#555555"
    />
  </svg>
);

export const arrowOnLink = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.05355 5.49914C4.31918 5.76486 4.74993 5.76486 5.01561 5.49914C5.28128 5.23342 5.28128 4.80257 5.01561 4.53685L3.53803 3.05891C3.2724 2.79319 2.84164 2.79319 2.57596 3.05891C2.31029 3.32463 2.31029 3.75548 2.57596 4.0212L4.05355 5.49914Z"
      fill="white"
    />
    <path
      d="M3.59442 7.96544C3.69107 7.60225 3.4751 7.2295 3.11201 7.13286L1.09319 6.59539C0.730191 6.49856 0.357439 6.71475 0.260839 7.07789C0.164238 7.44103 0.380161 7.81382 0.743253 7.91047L2.76207 8.44799C3.11532 8.54509 3.49909 8.33157 3.59442 7.96544Z"
      fill="white"
    />
    <path
      d="M6.64856 3.59543C6.74389 3.96156 7.12762 4.17504 7.48091 4.07794C7.84396 3.98129 8.05993 3.60854 7.96333 3.24536L7.42594 1.22599C7.3293 0.862811 6.95655 0.646933 6.59359 0.743489C6.23054 0.840135 6.01458 1.21289 6.11118 1.57607L6.64856 3.59543Z"
      fill="white"
    />
    <path
      d="M14.2073 9.8728C14.9031 9.17687 15.2865 8.25123 15.2869 7.26595C15.2869 6.28075 14.9035 5.3547 14.2073 4.65832C12.77 3.22069 10.4314 3.22064 8.99413 4.65832L7.64725 6.00556C7.38158 6.27128 7.38158 6.70212 7.64725 6.96784C7.91297 7.23361 8.34364 7.23361 8.60932 6.96784L9.95619 5.6206C10.863 4.71365 12.3384 4.71355 13.2452 5.6206C13.6844 6.05993 13.9263 6.64425 13.9263 7.26563C13.926 7.88732 13.6841 8.4715 13.2452 8.91052L11.8984 10.2578C11.6327 10.5236 11.6327 10.9544 11.8984 11.2201C12.0312 11.353 12.2053 11.4194 12.3794 11.4194C12.5534 11.4194 12.7276 11.353 12.8604 11.2201L14.2073 9.8728Z"
      fill="white"
    />
    <path
      d="M9.77273 12.3842L8.42585 13.7314C7.51907 14.6384 6.04362 14.6384 5.1368 13.7314C4.69761 13.2921 4.45574 12.7077 4.45574 12.0864C4.45601 11.4647 4.69793 10.8805 5.1368 10.4415L6.48372 9.0942C6.74935 8.82848 6.74935 8.39763 6.48372 8.13191C6.21809 7.86619 5.78734 7.86619 5.52166 8.13191L4.17478 9.47919C3.47903 10.1751 3.09567 11.1008 3.09521 12.0861C3.09521 13.0712 3.47862 13.9973 4.17478 14.6937C4.87104 15.3901 5.79681 15.7737 6.78155 15.7736C7.7662 15.7736 8.69184 15.3901 9.38796 14.6937L10.7348 13.3464C11.0005 13.0807 11.0005 12.6499 10.7348 12.3842C10.4691 12.1183 10.0384 12.1184 9.77273 12.3842Z"
      fill="white"
    />
    <path
      d="M11.5502 7.31599C11.2846 7.05027 10.8538 7.05027 10.5881 7.31599L6.83158 11.0735C6.56591 11.3393 6.56591 11.7701 6.83158 12.0358C6.96442 12.1687 7.13853 12.2351 7.31259 12.2351C7.48665 12.2351 7.6608 12.1687 7.7936 12.0358L11.5501 8.27828C11.8159 8.01256 11.8159 7.58171 11.5502 7.31599Z"
      fill="white"
    />
    <path
      d="M23.451 16.0431C23.4107 15.7717 23.2114 15.551 22.9456 15.4834L13.3971 13.0566C12.9162 12.9186 12.4323 13.4029 12.5703 13.8837L14.997 23.4341C15.1228 24.006 15.9506 24.1308 16.2387 23.6182L17.6174 21.335L19.2392 22.6008C20.0528 23.2356 21.2165 23.1641 21.9461 22.4343C22.6758 21.7045 22.7473 20.5405 22.1126 19.7267L20.847 18.1044L23.1298 16.7254C23.3646 16.5835 23.4912 16.3145 23.451 16.0431ZM19.4873 17.3359C19.1436 17.533 19.052 18.0302 19.3027 18.337L21.0398 20.5638C21.2527 20.8368 21.2288 21.2272 20.984 21.472C20.7392 21.7167 20.3489 21.7407 20.0761 21.5278L17.8499 19.7902C17.5421 19.5392 17.0464 19.6313 16.8491 19.9749L15.915 21.5219L14.1707 14.6573L21.0339 16.4017L19.4873 17.3359Z"
      fill="white"
    />
  </svg>
);

export const plusSymbol = (
  <svg
    className="mt-1"
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_623_833)">
      <path
        d="M13.5103 5.63867C17.2563 5.63867 20.2915 8.67383 20.2915 12.4199C20.2915 16.166 17.2563 19.2012 13.5103 19.2012C9.76416 19.2012 6.729 16.166 6.729 12.4199C6.729 8.67383 9.76416 5.63867 13.5103 5.63867ZM17.4478 13.1855V11.6543C17.4478 11.4902 17.2837 11.3262 17.1196 11.3262H14.604V8.81055C14.604 8.64648 14.4399 8.48242 14.2759 8.48242H12.7446C12.5532 8.48242 12.4165 8.64648 12.4165 8.81055V11.3262H9.90088C9.70947 11.3262 9.57275 11.4902 9.57275 11.6543V13.1855C9.57275 13.377 9.70947 13.5137 9.90088 13.5137H12.4165V16.0293C12.4165 16.2207 12.5532 16.3574 12.7446 16.3574H14.2759C14.4399 16.3574 14.604 16.2207 14.604 16.0293V13.5137H17.1196C17.2837 13.5137 17.4478 13.377 17.4478 13.1855Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_623_833"
        x="0.729004"
        y="0.638672"
        width="29.5625"
        height="29.5625"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_623_833"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_623_833"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const userIcon = (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_623_759)">
      <path
        d="M8.22813 7.22554C9.22079 7.22554 10.0804 6.86952 10.7827 6.16708C11.485 5.46476 11.841 4.60543 11.841 3.61266C11.841 2.62023 11.485 1.76078 10.7826 1.05823C10.0801 0.356024 9.22068 0 8.22813 0C7.23536 0 6.37602 0.356024 5.6737 1.05835C4.97137 1.76067 4.61523 2.62011 4.61523 3.61266C4.61523 4.60543 4.97137 5.46488 5.67381 6.1672C6.37625 6.8694 7.2357 7.22554 8.22813 7.22554Z"
        fill="#555555"
      />
      <path
        d="M14.5497 11.5343C14.5294 11.242 14.4884 10.9231 14.4281 10.5865C14.3673 10.2473 14.2889 9.9266 14.195 9.63352C14.0981 9.3306 13.9663 9.03145 13.8033 8.74478C13.6341 8.44723 13.4355 8.18814 13.2125 7.97493C12.9794 7.75189 12.694 7.57256 12.364 7.44176C12.0351 7.31164 11.6706 7.24572 11.2807 7.24572C11.1275 7.24572 10.9795 7.30855 10.6935 7.49474C10.5175 7.60953 10.3116 7.74228 10.0818 7.8891C9.88529 8.0143 9.6191 8.1316 9.29031 8.2378C8.96954 8.3416 8.64384 8.39424 8.32237 8.39424C8.00091 8.39424 7.67532 8.3416 7.3542 8.2378C7.02576 8.13172 6.75957 8.01442 6.5633 7.88922C6.33568 7.74376 6.12968 7.61101 5.95104 7.49463C5.6654 7.30843 5.5172 7.24561 5.36407 7.24561C4.97406 7.24561 4.60968 7.31164 4.28089 7.44187C3.95107 7.57245 3.66554 7.75178 3.4322 7.97505C3.20938 8.18837 3.0106 8.44734 2.84168 8.74478C2.67883 9.03145 2.547 9.33048 2.44995 9.63363C2.35622 9.92672 2.27783 10.2473 2.21695 10.5865C2.15664 10.9227 2.11567 11.2416 2.09541 11.5346C2.0755 11.8216 2.06543 12.1195 2.06543 12.4204C2.06543 13.2034 2.31434 13.8373 2.80518 14.3048C3.28995 14.7661 3.93139 15.0001 4.71142 15.0001H11.934C12.714 15.0001 13.3553 14.7662 13.8401 14.3048C14.3311 13.8376 14.58 13.2036 14.58 12.4203C14.5799 12.118 14.5697 11.8199 14.5497 11.5343Z"
        fill="#555555"
      />
    </g>
    <defs>
      <clipPath id="clip0_623_759">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0.834961)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const wishlistIcon = (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4873 1.69812C17.8311 3.66687 17.4873 6.88562 15.8311 8.60437L10.3311 14.1981C10.0186 14.5106 9.6123 14.6981 9.1748 14.6981C8.70605 14.6981 8.2998 14.5106 7.9873 14.1981L2.51855 8.60437C0.831055 6.88562 0.487305 3.66687 2.83105 1.69812C4.64355 0.16687 7.4248 0.38562 9.1748 2.16687C10.8936 0.38562 13.6748 0.16687 15.4873 1.69812ZM14.7373 7.54187C15.8936 6.38562 16.1123 4.19812 14.5186 2.82312C13.2998 1.82312 11.4248 1.97937 10.2686 3.16687L9.1748 4.29187L8.08105 3.16687C6.89355 1.97937 5.01855 1.82312 3.7998 2.85437C2.20605 4.19812 2.4248 6.38562 3.58105 7.54187L9.0498 13.1356C9.14355 13.1981 9.20605 13.1981 9.26855 13.1356L14.7373 7.54187Z"
      fill="#3A6D33"
    />
  </svg>
);

export const prevPaginationArrow = (
  <svg
    width="46"
    height="40"
    viewBox="0 0 46 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3.00488" width="40" height="40" rx="20" fill="white" />
    <path
      d="M20.1924 19.92V21.3887C20.1924 22.045 19.3799 22.3887 18.9111 21.92L16.2236 19.2012C15.9111 18.92 15.9111 18.4512 16.2236 18.17L18.9111 15.4512C19.3799 14.9825 20.1924 15.3262 20.1924 15.9825V17.42H29.6299C29.8174 17.42 30.0049 17.6075 30.0049 17.795V19.545C30.0049 19.7637 29.8174 19.92 29.6299 19.92H20.1924Z"
      fill="#777777"
    />
  </svg>
);
export const nextPaginationArrow = (
  <svg
    width="45"
    height="40"
    viewBox="0 0 45 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2.00488" width="40" height="40" rx="20" fill="white" />
    <path
      d="M24.7861 17.42V15.9825C24.7861 15.3262 25.5986 14.9825 26.0674 15.4512L28.7549 18.17C29.0674 18.4512 29.0674 18.92 28.7549 19.2012L26.0674 21.92C25.5986 22.3887 24.7861 22.045 24.7861 21.3887V19.92H15.3799C15.1611 19.92 15.0049 19.7637 15.0049 19.545V17.795C15.0049 17.6075 15.1611 17.42 15.3799 17.42H24.7861Z"
      fill="#777777"
    />
  </svg>
);

export const mailIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_728_187)">
      <path
        d="M20.0464 9.14264C20.1558 9.06061 20.3198 9.14264 20.3198 9.27936V14.8575C20.3198 15.5958 19.7183 16.17 19.0073 16.17H7.63232C6.89404 16.17 6.31982 15.5958 6.31982 14.8575V9.27936C6.31982 9.14264 6.45654 9.06061 6.56592 9.14264C7.19482 9.63483 7.98779 10.2364 10.7769 12.2598C11.3511 12.67 12.3354 13.5723 13.3198 13.5723C14.2769 13.5723 15.2886 12.67 15.8354 12.2598C18.6245 10.2364 19.4175 9.63483 20.0464 9.14264ZM13.3198 12.67C12.6636 12.6973 11.7612 11.877 11.2964 11.5489C7.65967 8.92389 7.38623 8.6778 6.56592 8.02155C6.40186 7.91217 6.31982 7.72076 6.31982 7.50201V6.98248C6.31982 6.27155 6.89404 5.66998 7.63232 5.66998H19.0073C19.7183 5.66998 20.3198 6.27155 20.3198 6.98248V7.50201C20.3198 7.72076 20.2104 7.91217 20.0464 8.02155C19.2261 8.6778 18.9526 8.92389 15.3159 11.5489C14.8511 11.877 13.9487 12.6973 13.3198 12.67Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_728_187"
        x="0.319824"
        y="0.669983"
        width="30"
        height="26.5"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_728_187"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_728_187"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const locationmark = (
  <svg
    className="ms-1"
    style={{ minWidth: "16px", minHeight: "21px" }}
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.21875 19.7761C1.51562 11.5729 0.5 10.7136 0.5 7.66669C0.5 3.52606 3.82031 0.166687 8 0.166687C12.1406 0.166687 15.5 3.52606 15.5 7.66669C15.5 10.7136 14.4453 11.5729 8.74219 19.7761C8.39062 20.3229 7.57031 20.3229 7.21875 19.7761ZM8 10.7917C9.71875 10.7917 11.125 9.4245 11.125 7.66669C11.125 5.94794 9.71875 4.54169 8 4.54169C6.24219 4.54169 4.875 5.94794 4.875 7.66669C4.875 9.4245 6.24219 10.7917 8 10.7917Z"
      fill="white"
    />
  </svg>
);

export const callIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9141 14.3273C20.2266 14.4836 20.4609 14.8351 20.4609 15.2257C20.4609 15.2648 20.4609 15.3429 20.4609 15.4211L19.5234 19.4836C19.4062 19.9132 19.0547 20.1867 18.625 20.1867C8.58594 20.1867 0.5 12.1007 0.5 2.06168C0.5 1.63199 0.773438 1.28043 1.20312 1.16324L5.26562 0.225739C5.34375 0.225739 5.42188 0.186676 5.46094 0.186676C5.85156 0.186676 6.20312 0.421051 6.35938 0.772614L8.23438 5.14761C8.27344 5.2648 8.3125 5.38199 8.3125 5.49918C8.3125 5.81168 8.15625 6.08511 7.96094 6.24136L5.57812 8.19449C7.02344 11.2414 9.44531 13.6632 12.4922 15.1086L14.4453 12.7257C14.6016 12.5304 14.875 12.3742 15.1484 12.3742C15.3047 12.3742 15.4219 12.4132 15.5391 12.4523L19.9141 14.3273Z"
      fill="white"
    />
  </svg>
);

export const mailIcon2 = (
  <svg
    width="21"
    className="mt-1"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1094 5.63762C20.2656 5.52043 20.5 5.63762 20.5 5.83293V13.8017C20.5 14.8564 19.6406 15.6767 18.625 15.6767H2.375C1.32031 15.6767 0.5 14.8564 0.5 13.8017V5.83293C0.5 5.63762 0.695312 5.52043 0.851562 5.63762C1.75 6.34074 2.88281 7.20012 6.86719 10.0907C7.6875 10.6767 9.09375 11.9657 10.5 11.9657C11.8672 11.9657 13.3125 10.6767 14.0938 10.0907C18.0781 7.20012 19.2109 6.34074 20.1094 5.63762ZM10.5 10.6767C9.5625 10.7157 8.27344 9.54387 7.60938 9.07512C2.41406 5.32512 2.02344 4.97356 0.851562 4.03606C0.617188 3.87981 0.5 3.60637 0.5 3.29387V2.55168C0.5 1.53606 1.32031 0.676682 2.375 0.676682H18.625C19.6406 0.676682 20.5 1.53606 20.5 2.55168V3.29387C20.5 3.60637 20.3438 3.87981 20.1094 4.03606C18.9375 4.97356 18.5469 5.32512 13.3516 9.07512C12.6875 9.54387 11.3984 10.7157 10.5 10.6767Z"
      fill="white"
    />
  </svg>
);

export const UserIcon = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    ></path>
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 21l-4.35-4.35m1.35-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
    ></path>
  </svg>
);

export const HamburgerIcon = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 6h16M4 12h16M4 18h16"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M19 9l-7 7-7-7"
    ></path>
  </svg>
);

export const InfoIcon = () => (
  <svg
    xmlns="http://www.w.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

export const GearIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </svg>
);

export const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);
